import React, { Component, PropTypes } from 'react';
import { Dialog, Button, InputGroup, ProgressBar, Intent } from '@blueprintjs/core';
import { Row, Column as Col } from 'hedron';

class Select extends Component {

  constructor(props) {
    super(props);
    this.renderOptions = this.renderOptions.bind(this);
  }

  renderOptions() {
    return this.props.options.map((option) => (
      <option
        value={option.value}
        key={`${this.props.controlId}_${option.label}`}
      >
        {option.label}
      </option>
    ))
  }

  render() {
    return (
      <Col xs={this.props.xs} sm={this.props.sm} md={this.props.md} lg={this.props.lg}>
        <label className="pt-label">
          {this.props.label}
          <div className="pt-select">
            <select
              value={this.props.value}
              onChange={this.props.onChange}
            >
              <option value="">{this.props.placeholder || 'Wählen...'}</option>
              {this.renderOptions()}
            </select>
          </div>
        </label>
      </Col>
    );
  }
}

Select.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  controlId: PropTypes.string,
  validationState: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string,
  })),
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
}

export default Select;



/** WEBPACK FOOTER **
 ** ./src/form/Select.js
 **/